import { React, useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import DropDownPicker from 'react-native-dropdown-picker';

import { useTranslation } from '../i18n';

export default function UpdateDefaultOrganization({
  user,
  organization,
  organizations,
  postUpdateAction,
  multiple,
  fullWidth = false,
}) {
  const { t } = useTranslation('common');
  const [orgOpen, setOrgOpen] = useState(false);
  const [orgValue, setOrgValue] = useState(organization ? organization : null);
  const [orgFilter, setOrgFilter] = useState(
    organizations.map((x) => {
      return { label: x, value: x };
    }),
  );

  useEffect(() => {
    if (organization && organization != orgValue) {
      postUpdateAction(user, orgValue);
    }
  }, [orgValue]);

  return (
    <DropDownPicker
      style={{
        minHeight: fullWidth ? 40 : 28,
        maxHeight: fullWidth ? 40 : 28,
        marginTop: 5,
        border: fullWidth ? 1 : 0,
        borderColor: '#E5E7EB',
        borderRadius: fullWidth ? 12 : 4,
        width: fullWidth ? '100%' : 120,
        backgroundColor: fullWidth ? '#ffffff' : 'transparent',
      }}
      badgeStyle={{
        cursor: 'pointer',
        padding: fullWidth ? 6 : 2,
      }}
      badgeTextStyle={{
        fontSize: fullWidth ? 14 : 12,
      }}
      badgeColors={['#FFC451']}
      badgeDotColors={['#ffffff']}
      textStyle={{
        fontSize: fullWidth ? 14 : 12,
      }}
      containerStyle={{
        width: fullWidth ? '100%' : 120,
        position: 'relative',
      }}
      dropDownContainerStyle={{
        width: fullWidth ? '100%' : 120,
        borderColor: '#E5E7EB',
        backgroundColor: '#ffffff',
        borderWidth: 1,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.15,
        shadowRadius: 8,
        elevation: 10,
      }}
      listItemContainerStyle={{
        backgroundColor: '#ffffff',
      }}
      selectedItemContainerStyle={{
        backgroundColor: '#FFF8E7',
      }}
      listMode={fullWidth ? 'SCROLLVIEW' : 'FLATLIST'}
      scrollViewProps={{
        nestedScrollEnabled: true,
      }}
      zIndex={fullWidth ? 1000 : 9}
      zIndexInverse={fullWidth ? 1000 : 9}
      multiple={multiple}
      min={1}
      open={orgOpen}
      value={orgValue}
      items={orgFilter}
      setOpen={setOrgOpen}
      setValue={setOrgValue}
      setItems={setOrgFilter}
      placeholder={t('state.none')}
      dropDownDirection={fullWidth ? 'AUTO' : 'TOP'}
      showArrowIcon={true}
      selectable={true}
      maxHeight={158}
      extendableBadgeContainer={true}
      showBadgeDot={false}
    />
  );
}
const styles = StyleSheet.create({
  button: {
    cursor: 'pointer',
    marginVertical: 10,
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 5,
    width: 95,
    backgroundColor: '#FFC451',
  },
  buttonText: {
    fontSize: 12,
    fontWeight: '600',
  },
});
